import { gql } from "@apollo/client";

export const GET_CUIDADOS_DOMICILIARIOS_RESUMEN = gql`
query CuidadosDomiciliariosRIByID (
    $idDatosGenerales: Int!
) {
    cuidadosDomiciliariosRIById (
        idDatosGeneralesRI: $idDatosGenerales
    ){
        cuidadosDomiciliariosRI {
            sNC
            cV
            respiratorio
            digestivo
            videodeglucion
            otros
            traqueostomia
            sondaVesical
            ostomia
            cateter
            sondaNasogastrica
            idComboRIValorCalendarioVacunasNavigation{
                valor
            }
            idComboRIValorAduKarnofskyNavigation{
                valor
            }
            idComboRIValorPedLANSKYNavigation{
                valor
            }
            requiereSoporteNutricional
            idComboRIValorTabaquismoNavigation{
                valor
            }
            antecedentesAlcoholismo
            antecedentesConsumoSustancias
            tipoSustancia
            infusionDrogas
            drogasAInfundir
            dosis
            frecuencia
            cumpleCriterioIngreso
            infusionesPrevias
            cuantas
            donde
            reaccionesAdversas
        }
        videodeglucionAdjunto {
            contentType
            titulo
            archivo
            extension
        }
    }
}`;